import styled from 'styled-components'

export const BoxTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 37px;

  hgroup {
    margin-bottom: 30px;

    h4 {
      margin: 0px;
      color: var(--text-tertiary);
      font-size: var(--font-size-ssm);
      font-weight: light;
    }
  }
`

export const Content = styled.main`
  h2 {
    font-size: var(--font-size-md);
    color: var(--text-tertiary);
    font-weight: bold;
    margin: 15px 0;
  }

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    span {
      font-size: var(--font-size-sm);
      color: var(--text-tertiary);
    }
  }

  footer {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    div:last-child {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 10px;
    }
  }

  textarea {
    width: 100%;
    height: auto;
    resize: none;
    background-color: #f8f8f8;
    padding: 12px 20px;
    border-radius: 4px;
  }

  li {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    label {
      margin-bottom: 0;
    }
  }

  p {
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
    margin: 0;
  }
`

export const GroupRadios = styled.ul`
  display: flex;
  flex-direction: row;
  gap: 35px;

  @media (max-width: 575px) {
    align-items: center;
    flex-wrap: wrap;
    gap: 0;
  }
`

export const WrapperAnswers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 1200px) {
    flex-direction: row;
  }
`

export const TopContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`
